<template>
    <div class="informacion-autenticacion">
        <div class="desktop-info mt-5">
            <p>
                <strong v-if="esExtranjero()">We will now only validate your identity</strong>
                <strong v-else>Ahora solo validaremos tu identidad</strong>
            </p>
            <p class="mt-3"
                v-html="esExtranjero() ? 'With your <b>Smartphone</b>, scan the QR code below to start the process.' : 'Con tu <b>Smartphone</b>, escanea el código QR para comenzar el proceso.'">
            </p>
            <br>
            <QrcodeVue :value="this.urlToCopy" size="150" level="H"></QrcodeVue>
            <p class="mt-5" v-html="esExtranjero() ? 'or copy the following link' : 'O copia la siguiente liga'"></p>
            <div class="campo-texto mt-2">
                <input type="text" :placeholder="this.urlToCopy" readonly>
                <button class="btn btn-icon boton-copiar" @click="copiarTexto()">
                    <i class="far fa-copy"></i>
                </button>
            </div>
            <button class="mt-5 btn boton-primario w-25 p-3" @click="regresar()">{{esExtranjero() ? 'Accept' : 'Aceptar'}}</button>
        </div>
    </div>
</template>

<script lang="js">
import servicios from "../../../servicios/service.js";
import QrcodeVue from 'qrcode.vue'

export default {
    name: "InformacionAutenticacionIdentidad",
    components: {
        QrcodeVue
    },
    data() {
        return {
            urlToCopy: window.location.origin + `/LoginMaster?preonboarding=true&isforeign=${ this.esExtranjero() ? 'true' : 'false' }`,
        }
    },
    methods: {
        regresar() {
            switch(this.$store.getters.tipoPersona) {
                case 0:
                    this.$router.push({ name: "IntegracionExpediente" });
                    break;
                case 1:
                    this.$router.push({ name: "IntegracionExpedienteMoral" });
                    break;
                case 2:
                case 5:
                case 7:
                    this.$router.push({ name: "IntegracionExpedienteExtranjero" });
                    break;
                default:
                    this.$router.push({ name: "IntegracionExpediente" });
                    break;
            }
        },
        esExtranjero() {
            return servicios.esExtranjero(this.$store.getters.tipoPersona);
        },
        copiarTexto() {
            navigator.clipboard.writeText(this.urlToCopy);
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.informacion-autenticacion p {
    color: #1e2120;
    font-size: 16px;
}

.informacion-autenticacion .bold-text {
    font-weight: bold !important;
}

.campo-texto {
    width: 20% !important;
    display: flex;
    align-items: center;
    padding: 5px;
    background-color: #f5f5f5;
    width: 100%;
    border-radius: 5px;
}

.campo-texto input {
    flex: 1;
    border: none;
    background-color: transparent;
    opacity: 0.7;
    margin-left: 10px;
}

.boton-copiar {
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-left: 5px;
}

.boton-copiar i {
    color: #b8725a;
}

.desktop-info {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mobile-info strong {
    font-size: 22px;
}

.mobile-info button {
    margin-top: 40%;
}
</style>
